import { createApp } from 'vue'
import App from './AboutHPPC.vue'

createApp(App).mount('#app-about-hppc')
